<a
  href="#"
  class="tooltip"
  [ngClass]="{ 'no-icon': label, 'help-icon': helpIcon }"
  [attr.aria-label]="getARIALabelText()"
  (blur)="hide()"
  (click)="click($event)"
  (focus)="show()"
  #tooltip
>
  <span class="tooltip-label-text">{{ label }}</span>
  <span
    class="tooltip-container position-{{ positionX }} position-{{ positionY }}"
    [ngClass]="{ 'sr-only': !visible }"
    role="status"
  >
    <span
      [attr.aria-hidden]="!visible"
      class="tooltip-content"
      [innerHtml]="text"
    ></span>
  </span>
</a>
